import React from 'react';
import {
  House,
  Package,
  List,
  Truck,
  ClipboardCheck,
  Repeat,
  Inbox,
  Users,
  User,
  Settings,
  LogOut,
  ChevronDown,
  ChevronRight,
  PanelLeftClose,
  PanelLeftOpen,
  Search,
  CornerDownLeft,
  MoreHorizontal,
  Menu,
} from 'lucide-react';

// Maps the kebab-case icon names emitted by `app_nav_sections` (Rails) and used
// throughout the shell to their lucide-react components. Keeping the import list
// explicit lets webpack tree-shake to only these icons.
const ICONS = {
  house: House,
  package: Package,
  list: List,
  truck: Truck,
  'clipboard-check': ClipboardCheck,
  repeat: Repeat,
  inbox: Inbox,
  users: Users,
  user: User,
  settings: Settings,
  'log-out': LogOut,
  'chevron-down': ChevronDown,
  'chevron-right': ChevronRight,
  menu: Menu,
  'panel-left-close': PanelLeftClose,
  'panel-left-open': PanelLeftOpen,
  search: Search,
  'corner-down-left': CornerDownLeft,
  'more-horizontal': MoreHorizontal,
};

// Thin 1.75 stroke matches the canvas' Lucide rendering.
const Icon = ({ name, size = 18, color = 'currentColor', style }) => {
  const Cmp = ICONS[name] || Package;
  return (
    <Cmp
      size={size}
      color={color}
      strokeWidth={1.75}
      style={{ flex: 'none', display: 'block', ...style }}
      aria-hidden="true"
    />
  );
};

export default Icon;
